import * as React from 'react'

import { Text } from '~ui/components/typography/Text/Text'

import { useAddonDetailStateCtx } from '../contexts/AddonDetailStateProvider'

type TProps = NoChildren

/**
 * Price of the selected addon.
 */
export const AddonDetailPrice: React.FC<TProps> = () => {
  const { addon } = useAddonDetailStateCtx()
  return (
    <Text fontStyle={`bold`} fontSize={`l24`}>
      {addon.price.formattedValue}
    </Text>
  )
}
